import 'react';
import '../Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import '../utils/useTheme.js';
import '../utils/useLocalStorage.js';
import { a as _taggedTemplateLiteralLoose } from '../chunk-1b90139e.js';
import '../utils/omit.js';
import '../ColorMode/utils.js';
import '../ColorMode/ColorModeContext.js';
import '../ColorMode/InitializeColorMode.js';
import '../utils/pick.js';
import '../utils/cssProps.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import '../utils/isFunction.js';
import '../utils/get.js';
import { palette, borderRadius, space, theme, fontWeight, fontSize } from '../utils/theme.js';
import '../utils/getCSSFromStyleObject.js';
import '../utils/useStyle.js';
import '../utils/usePrevious.js';
import '../utils/useOptionsState.js';
import '../utils/omitBy.js';
import '../utils/useDefaultProps.js';
import '../utils/useDebounce.js';
import 'lodash/uniq';
import '../utils/useClassName.js';
import '../utils/getMediaQueryList.js';
import '../utils/useBreakpointValue.js';
import '../utils/useBreakpoint.js';
import 'reakit/Id';
import '../utils/uniqueId.js';
import '../utils/times.js';
import '../utils/parseIcons.js';
import '../utils/colors.js';
import '../utils/palette.js';
import '../utils/mergeRefs.js';
import 'deepmerge';
import 'lodash/set';
import '../utils/applyTheme.js';
import '../utils/bindFns.js';
import '../utils/createComponent.js';
import '../utils/createElement.js';
import '../utils/createHook.js';
import '../utils/forwardRefWithUse.js';
import '../utils/fieldAdaptors.js';
import 'capsize';
import '../utils/getCapsizeStyles.js';
import '@emotion/is-prop-valid';
import '../utils/htmlProps.js';
import '../utils/OutsideClickHandler.js';

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: ", "rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: ", ";\n  font-size: ", "em;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", "rem;\n  align-items: center;\n  justify-content: space-between;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Card = function Card(styleProps) {
  return css(_templateObject(), palette('background', {
    dark: 'gray900'
  })(styleProps), borderRadius('default')(styleProps), space(3, 'major')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var CardContent = function CardContent(styleProps) {
  return css(_templateObject2(), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var CardHeader = function CardHeader(styleProps) {
  return css(_templateObject3(), space(2, 'major')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var CardTitle = function CardTitle(styleProps) {
  return css(_templateObject4(), fontWeight('semibold')(styleProps), fontSize('300')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var CardFooter = function CardFooter(styleProps) {
  return css(_templateObject5(), space(3, 'major')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var styles = /*#__PURE__*/Object.freeze({
  Card: Card,
  CardContent: CardContent,
  CardHeader: CardHeader,
  CardTitle: CardTitle,
  CardFooter: CardFooter
});
export { Card as C, CardContent as a, CardHeader as b, CardTitle as c, CardFooter as d, styles as s };